import { Dropdown } from "antd";
import { MoreOptionBtn } from "../Buttons";

export const MoreOptionsColumn = ({ data, MenuItems, handleMenuItemClick }) => {
  return (
    <>
      <Dropdown
        menu={{
          items: MenuItems(data),
          onClick: (e) => handleMenuItemClick(e, data),
        }}
        placement="bottomRight"
        arrow={{
          pointAtCenter: true,
        }}
      >
        <MoreOptionBtn />
      </Dropdown>
    </>
  );
};
